var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussiaGosloto5From50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "6 6 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 33.143c7.259 0 13.143-5.884 13.143-13.143S27.259 6.857 20 6.857 6.857 12.741 6.857 20 12.742 33.143 20 33.143z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.26 26.78a6.459 6.459 0 0 1-.478.735 1.43 1.43 0 0 0 .957.11l-.478-.846zm-12.89-3.771c-1.729-4.034-7.481-3.972-11.478-3.972l-.878.398.582 1.114h.28c.172 4.019 2.203 8.065 5.131 10.366 3.957.273 7.635-4.937 6.363-7.906z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.998 22.884c-6.115-3.207-4.993-12.726-5.575-13.807a2.501 2.501 0 0 0-1.126-1.104l-.143-.064a25.83 25.83 0 0 0-1.489-.499.39.39 0 0 0 .013-.174c-.034-.04-.294-.433-.344-.499a7.055 7.055 0 0 0-.876-.439c-.033 0-1.16-.15-1.727.141a3.59 3.59 0 0 0-.621.414l.52.02c.428.028.852.093 1.269.196.793.207 1.091.946 1.091 1.983s-.828 4.334-3.388 4.334c-2.464 0-4.18-.207-10.81-.254l-.135.231-.147.255a10.117 10.117 0 0 0-.267.508 10.16 10.16 0 0 0-.327.706c-.034.078-.065.157-.098.238l-.437-.065a10.73 10.73 0 0 1-.921 1.431c.219.207.484.358.774.44 5.347 0 11.132.047 13.402 4.627 2.756 5.56-3.727 10.803-6.09 10.439a12.637 12.637 0 0 1-1.864-1.036 3.21 3.21 0 0 0 1.508 1.819l1.716.163v-.414l.298.095c.148.046.296.087.446.127l.24.06.335.076.22.046.534.097c4.189-.505 7.473-6.877 10.068-6.877 2.29 0 2.953 1.013 2.975 1.046a13.06 13.06 0 0 0 1.624-3.578c-.052-.197-.222-.458-.648-.681z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.271 18.085-.286-.1c-.39-2.585-1.529-5-3.278-6.943a1.2 1.2 0 0 0 .104-.325c-.017-.025-.414-.797-.414-.828s-.462-.677-.76-.808a3.76 3.76 0 0 0-1.617-.207l.828.584c1.087.967.99 1.112 1.49 5.41.415 3.457 3.07 5.117 3.8 5.51l.858.028-.725-2.321z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.449 29.134a7.739 7.739 0 0 0-1.864-.186c-1.675 0-3.464 3.65-6.475 4.14-.37.04-.74.057-1.112.055a2.201 2.201 0 0 0 1.534.745l2.754-1.182a1.43 1.43 0 0 0 .276-.207.18.18 0 0 0 .016-.03 14.95 14.95 0 0 0 3.935-2.484l.107.153 1.309-.292s-.101-.63-.48-.712zM10.723 10.692l.265-.072h.965c1.758.035 6.295.799 7.337.426s1.217-2.716.785-3.857c-.208-.568-.918-.75-1.57-.79a12.774 12.774 0 0 0-6.4 2.91l-.278-.246-1.71 1.035c-.27.275.175 1.056.175 1.056l.431-.462z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.898 22.756c1.576 2.953-2.323 8.544-6.539 8.254A13.973 13.973 0 0 1 6 20c0-.19 0-.377.014-.565 4.254 0 10.16.07 11.884 3.321zm14.882.317c-6.512-3.417-5.317-13.557-5.936-14.702a2.653 2.653 0 0 0-1.201-1.176c-.05-.023-.1-.048-.152-.069a22.571 22.571 0 0 0-3.027-.898c-1.101-.155-1.733.217-1.733.217s.4-.223 1.263-.089c.913.143 1.462.828 1.462 1.936S22.723 13.53 20 13.53c-2.624 0-4.879-.778-11.94-.828-.05.08-.097.163-.145.246l-.155.272a11.494 11.494 0 0 0-.284.54l-.13.26a13.65 13.65 0 0 0-.222.492l-.103.252a12.87 12.87 0 0 0-.122.31l-.1.276c-.037.104-.07.207-.105.31l-.087.27c-.054.176-.104.354-.151.532 5.696 0 11.803-.281 14.596 5.177 3.019 5.879-4.349 11.494-6.867 11.105a16.76 16.76 0 0 0 1.243.503l.151.05a15.838 15.838 0 0 0 .839.253l.254.062.359.083.234.05a14.39 14.39 0 0 0 .57.1c4.463-.538 7.96-7.323 10.725-7.323 2.438 0 3.146 1.076 3.168 1.114a14.003 14.003 0 0 0 1.731-3.813c-.043-.233-.207-.51-.679-.75zM19.807 6.859c-.223-.53-.95-.7-1.627-.737a13.96 13.96 0 0 0-8.063 3.963 21.67 21.67 0 0 1 1.275-.016c1.822.033 6.523.747 7.602.4s1.26-2.541.813-3.61zm9.422 2.618a2.335 2.335 0 0 0-.6-.39 1.242 1.242 0 0 0-.32-.097c1.16 1.035 1.1.973 1.634 5.552.43 3.681 3.268 5.452 4.047 5.872V20a13.962 13.962 0 0 0-4.76-10.52v-.003zm.71 20.38a6.478 6.478 0 0 0-1.863-.325c-1.804 0-4.096 4.273-7.008 4.273a.71.71 0 0 0 .249.063 2.3 2.3 0 0 0 .621 0 13.949 13.949 0 0 0 8.001-4.011z",
    fill: "url(#c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.971 15.552) scale(17.6527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b8f200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#b5ee00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#aae300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#99d000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#81b500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#639300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#548200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71aa01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(69.03 4.486 30.053) scale(7.30957 3.43549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0e0e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f2f2f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.909 17.37) scale(14.089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0e0e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f2f2f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussiaGosloto5From50);
export default __webpack_public_path__ + "static/media/russia_gosloto_5_from_50.250083e53de32cb8d484af6a3d343f99.svg";
export { ForwardRef as ReactComponent };